import { CampaignStatus } from '@ospace/schemas'
import { ErrorBoundary } from '@ospace/shared'
import { useParams } from 'react-router-dom'

import { useCampaign, useCampaignDashboard } from '../../hooks'
import { CampaignLayout } from './CampaignLayout'
import { Loader } from '@mantine/core'

type IntelType = 'intent' | 'contact'
type Props = {
  campaignId: number
  intelType: IntelType
}
export const DataIntelPage = (props: Props) => {
  const { campaignId, intelType } = props
  const { data: campaign, isFetching: isFetchingCampaign } = useCampaign(campaignId)
  const { data: dashboards, isFetching } = useCampaignDashboard(campaignId, intelType)

  let dashboardUrl
  if (props.intelType === 'intent') {
    dashboardUrl = dashboards?.dashboardForIntent
    if (campaign?.status !== CampaignStatus.IN_PROGRESS) {
      dashboardUrl = dashboards?.endedDashboardForIntent
    }
  } else if (props.intelType === 'contact') {
    dashboardUrl = dashboards?.dashboardForContact
  }
  return (
    <CampaignLayout>
      {isFetching && isFetchingCampaign ? (
        <div
          className='d-flex align-items-center justify-content-center'
          style={{ minHeight: '60vh' }}
        >
          <Loader color='blue' />
        </div>
      ) : (
        <iframe title='intent' width='100%' style={{ height: '100vh' }} src={dashboardUrl} />
      )}
    </CampaignLayout>
  )
}

const Controller = () => {
  const { id, intelType }: any = useParams()
  return <DataIntelPage campaignId={Number(id)} intelType={intelType} />
}

export const DataIntelPageRouteHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)
